<!-- <mat-card *ngIf="loadingBatch"> -->
<mat-card *ngIf="loadingBatch">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="requisitionId"><strong>Nome do Arquivo</strong></label>
                    <span class="form-text" id="requisitionId"> {{ informBatchParam.fileName }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="collectorCode"><strong>Cobradora</strong></label>
                    <span class="form-text" id="collectorCode"> {{ informBatchParam.collectorCode }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="date"><strong>Data de Crédito</strong></label>
                    <span class="form-text" id="date"> {{ informBatchParam.date | date: 'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="createFor"><strong>Nº Itens</strong></label>
                    <span class="form-text" id="createFor"> {{ informBatchParam.quantityLines }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="valorTotal"><strong>Valor com Pendências</strong></label>
                    <span class="form-text" id="valorPendency"> {{ countStatusLine.valuePendency | currency }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="valorTotal"><strong>A Creditar</strong></label>
                    <span class="form-text" id="valorProcessing"> {{ countStatusLine.valueStandBy | currency }}</span>
                </div>
            </div>

            <div class="col" *ngIf="countStatusLine.failed !== 0">
                <div class="form-group">
                    <label class="form-text" for="valorTotal"><strong>Falhas</strong></label>
                    <span class="form-text" id="valorFailed"> {{ countStatusLine.valueFailed | currency }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="valorTotal"><strong>Creditados</strong></label>
                    <span class="form-text" id="valorSucceeded"> {{ countStatusLine.valueSucceeded | currency }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text" for="valorTotal"><strong>TOTAL</strong></label>
                    <span class="form-text" id="valorSucceeded">
                        {{
                        countStatusLine.valuePendency +
                        countStatusLine.valueProcessing +
                        countStatusLine.valueFailed +
                        countStatusLine.valueSucceeded | currency
                        }}</span>
                </div>
            </div>
        </div>
    </div>

    <mat-tab-group animationDuration="0ms" dynamicHeight >
        <mat-tab label="Detalhes">
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field class="wd-100" [floatLabel]="'auto'" appearance="outline">
                        <mat-label> Nº Fatura </mat-label>
                        <input matInput [(ngModel)]="searchCountStatus.billetNumber" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="wd-100" [floatLabel]="'auto'" appearance="outline">
                        <mat-label> Valor Fatura </mat-label>
                        <input matInput [(ngModel)]="searchCountStatus.billetValue" />
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field class="wd-100" [floatLabel]="'auto'" appearance="outline">
                        <mat-label>Vencimento da Fatura</mat-label>
                        <input matInput [matDatepicker]="basicDatepicker"
                            [(ngModel)]="searchCountStatus.billetDueDate" />
                        <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #basicDatepicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-md-4 text-right">
                    <button class="btn btn-primary p-4" type="button" (click)="loadingTable(this.typeFilter)"
                        id="btnSearchCountStatus" data-toggle="tooltip" data-placement="top" title="Pesquisar">
                        <i class="fas fa-search"></i>
                    </button>
                    <button class="btn btn-success ml-1 p-4" type="button" (click)="cleanFilter('searchCountStatus')"
                        data-toggle="tooltip" data-placement="top" title="Limpar Pesquisar">
                        <i class="fas fa-broom"></i>
                    </button>
                </div>
            </div>

            <div class="row" style="align-items: center">
                <div class="col">
                    <div *ngIf="countFinalize" class="btn-group btn-group-toggle" [disabled]="disableSelectType"
                        ngbRadioGroup (ngModelChange)="loadingTable($event)" [(ngModel)]="typeFilter">
                        <label ngbButtonLabel class="btn-outline-warning btn-sm">
                            <input ngbButton type="radio" value="Pendency" /><span
                                class="badge badge-pill badge-warning pendecyBadge">{{ countStatusLine.pendency }}
                            </span>
                            Pendências
                        </label>
                        <label ngbButtonLabel class="btn-outline-primary btn-sm">
                            <input ngbButton type="radio" value="StandBy" /><span
                                class="badge badge-pill badge-primary">{{ countStatusLine.standBy }}
                            </span>
                            A creditar
                        </label>

                        <label *ngIf="countStatusLine.enqueued !== 0" ngbButtonLabel
                            class="btn-outline-secondary btn-sm">
                            <input ngbButton type="radio" value="Enqueued" /><span
                                class="badge badge-pill badge-secondary">{{ countStatusLine.enqueued }}
                            </span>
                            Na Fila
                        </label>

                        <label *ngIf="countStatusLine.processing !== 0" ngbButtonLabel class="btn-outline-info btn-sm">
                            <input ngbButton type="radio" value="Processing" /><span
                                class="badge badge-pill badge-info">{{ countStatusLine.processing }}
                            </span>
                            Processando
                        </label>

                        <label *ngIf="countStatusLine.failed !== 0" ngbButtonLabel class="btn-outline-danger btn-sm">
                            <input ngbButton type="radio" value="Failed" /><span
                                class="badge badge-pill badge-danger">{{ countStatusLine.failed }}
                            </span>
                            Falhas
                        </label>
                        <label ngbButtonLabel class="btn-outline-success btn-sm">
                            <input ngbButton type="radio" value="Succeeded" />
                            <span class="badge badge-pill badge-success">{{ countStatusLine.succeeded }} </span>
                            Creditados
                        </label>
                    </div>
                </div>

                <div class="col-md-3 flex-center" style="height: 40px; display: flex">
                    <div class="form-group formMonthAccounting" *ngIf="
                            typeFilter === 'Succeeded' &&
                            countStatusLine.standBy === 0 &&
                            countStatusLine.pendency === 0 &&
                            countStatusLine.failed === 0 &&
                            countStatusLine.processing === 0 &&
                            !configTable.accounting
                        ">
                        <label class="form-text" for="valueDevolution"><strong>Mês para contabilizar</strong></label>

                        <!-- <form [formGroup]="formDateAccounting" novalidate>
                            <month-date-picker name="dateAccounting"
                                formControlName="dateAccounting"></month-date-picker>
                        </form> -->
                    </div>
                </div>

                <div class="col"
                    style="display: flex; flex-direction: row; align-items: center; justify-content: flex-end">
                    

                    <div class="margin-lr-5">
                        <mat-icon class="btnResresh" (click)="refresh()">refresh</mat-icon>
                    </div>

                    

                    <div class="btn-group btnFloatRight margin-lr-5" *ngIf="
                            typeFilter === 'Succeeded' &&
                            countStatusLine.standBy === 0 &&
                            countStatusLine.pendency === 0 &&
                            countStatusLine.failed === 0 &&
                            countStatusLine.processing === 0 &&
                            !configTable.accounting
                        ">
                        <button (click)="Accounting()" class="btn btn-outline-primary btnAccount">Contabilizar</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <br />
                    <span *ngIf="countFinalize"><strong>Valor total: </strong>{{ valueSumForPage | currency }}</span>
                </div>
            </div>
            <div *ngIf="tableColsMockOk && dataSaleOff.length > 0">
                <custom-list [cols]="titleListColunNames" [titles]="titleList" [data]="dataSaleOff"
                    (reloadTable)="reloadingForAction($event)" [startLineSelected]="configTable.getSelected"
                    [config]="configTable" (resSelectLine)="returnSelect($event)"
                    (outSelectedLine)="selectedLine($event)" >
                </custom-list>
            </div>

            <div *ngIf="tableColsMockOk && dataSaleOff.length === 0">
                <mat-card>
                    <p class="notData">Não existem dados a serem carregados!</p>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
    <loader></loader>
</mat-card>
